import { render, staticRenderFns } from "./CompanyPropertiesForm.vue?vue&type=template&id=54f67bc0&"
import script from "./CompanyPropertiesForm.vue?vue&type=script&lang=js&"
export * from "./CompanyPropertiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f67bc0')) {
      api.createRecord('54f67bc0', component.options)
    } else {
      api.reload('54f67bc0', component.options)
    }
    module.hot.accept("./CompanyPropertiesForm.vue?vue&type=template&id=54f67bc0&", function () {
      api.rerender('54f67bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Companies/Forms/CompanyPropertiesForm.vue"
export default component.exports